import { render, staticRenderFns } from "./CsListboxItemConfirmation.vue?vue&type=template&id=23725960&"
import script from "./CsListboxItemConfirmation.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsListboxItemConfirmation.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports